import React from 'react';
import PropTypes from 'prop-types';
import Font from '@mui/icons-material/HowToReg';
import { Card, Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ApprovalTypeGeneralDataComponent = ({ dispatch, approvalTypeItem, competenceOrderDecisionBehaviorOptions, changed, validation }) => {
    const { t } = useTranslation();
  const onPropertyChanged = (propertyName, value) => {
    dispatch({ type: 'OnHeaderPropertyChanged', propertyName, value });
  };

  return (
    <Card icon={Font} iconColor='primary' title={t('ApprovalTypes.GeneralData')}>
      <>
        <Prompt when={changed && !approvalTypeItem.saving} message={t('ApprovalTypes.LeavingWithoutSavingApprovalType')} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              onChange={event => onPropertyChanged('approvalTypeCode', event)}
              value={approvalTypeItem.approvalTypeCode || ''}
              label={t('ApprovalTypes.ApprovalTypeCode')}
              error={!isValid(validation.approvalTypeCode)}
              helperText={getErrors(validation.approvalTypeCode)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              onChange={event => onPropertyChanged('approvalTypeName', event)}
              value={approvalTypeItem.approvalTypeName || ''}
              label={t('ApprovalTypes.ApprovalTypeName')}
              error={!isValid(validation.approvalTypeName)}
              helperText={getErrors(validation.approvalTypeName)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              fullWidth
              value={approvalTypeItem.decisionBehaviorId}
              simpleValue
              options={competenceOrderDecisionBehaviorOptions}
              label={t('ApprovalTypes.CompetenceOrderDecisionBehavior')}
              valueKey='decisionBehaviorId'
              labelKey='decisionBehaviorName'
              onChange={value => onPropertyChanged('decisionBehaviorId', value)}
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={approvalTypeItem.fourEyesPrinciple || false}
                  onChange={event => onPropertyChanged('fourEyesPrinciple', event.target.checked)}
                />
              }
              label={t('ApprovalTypes.FourEyesPrinciple')}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={approvalTypeItem.withNominalApproval || false}
                  onChange={event => onPropertyChanged('withNominalApproval', event.target.checked)}
                />
              }
              label={t('ApprovalTypes.WithNominalApproval')}
            />
          </Grid>
        </Grid>
      </>
    </Card>
  );
};

ApprovalTypeGeneralDataComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  approvalTypeItem: PropTypes.object.isRequired,
  competenceOrderDecisionBehaviorOptions: PropTypes.array.isRequired,
  changed: PropTypes.bool,
  validation: PropTypes.object.isRequired
};
export default ApprovalTypeGeneralDataComponent;
